import React from 'react';
import { Button, Icon, Tooltip } from '@gravity-ui/uikit';
import { Xmark, ArrowShapeTurnUpRight } from '@gravity-ui/icons';
import { videoListT } from '../../../i18n/videoList.i18n';

type ButtonAction = 'delete' | 'share';
type ButtonViewes = 'normal' | 'outlined-danger';

type ActionButtonProps = {
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    action: ButtonAction;
};

const viewByAction: Record<ButtonAction, ButtonViewes> = {
    delete: 'outlined-danger',
    share: 'normal',
};

const textByAction: Record<ButtonAction, string> = {
    delete: videoListT('actionDelete'),
    share: videoListT('actionShare'),
};

const iconByAction: Record<ButtonAction, JSX.Element> = {
    delete: <Icon data={Xmark} size={14} />,
    share: <Icon data={ArrowShapeTurnUpRight} size={14} />,
};

export function ActionButton({ onClick, action }: ActionButtonProps) {
    return (
        <Tooltip content={textByAction[action]}>
            <Button size="xs" view={viewByAction[action]} onClick={onClick}>
                {iconByAction[action]}
            </Button>
        </Tooltip>
    );
}
